import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import updateIconImg from "../../assets/updateIconImg.png";
import deleteIconImg from "../../assets/deleteIcon.png";
import addIcon from "../../assets/addWhiteIcon.png";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { Tooltip } from "primereact/tooltip";
import "./QuizModal.scss";
import Excalmation from "../../assets/Exclamation.png";
import ModalHeader from "../../components/Header/ModalHeader";
import QuizForm from "./QuizForm";
import DialogComponent from "../../components/Dialog";
import { deleteQuiz, getQuizFromServer, publishQuiz } from "../../services/QuizService";
import { InputSwitch } from "primereact/inputswitch";
import { Toast } from "primereact/toast";
import { useRef } from "react";
import QuizeViewModal from "./QuizeViewModal";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

function getUniqueValuesByKey(data, key) {
  const values = data.map((data) => data[key]);
  return [...new Set(values)];
}

function QuizzesView() {
  const [dataitem, setDataitem] = useState([]);
  const [showAddQuizModal, setShowAddQuizModal] = useState(false);
  const [showPublishDialog, setShowPublishDialog] = useState(false);
  const [selectedQuiz, setSelectedQuiz] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [filter] = useState(false);
  const dispatch = useDispatch();
  const [viewMappedQuiz, setViewMappedQuiz] = useState([]);
  const [showViewModal, setShowViewModal] = useState(false);
  const [isQuestionMapped, setIsQuestionMapped] = useState(false);
  const toast = useRef(null);

  const handleAddQuizClick = () => {
    setShowAddQuizModal(true);
  };
  const handleViewMappedQuestions = (quiz) => {
    setViewMappedQuiz(quiz);
    setShowViewModal(true);
    setIsQuestionMapped(true);
  };

  const handlePublishToggle = async (rowData) => {
    if (rowData.is_published) {
      toast.current.show({
        severity: "warn",
        summary: "Already Published",
        detail: "This quiz is already published and cannot be republished.",
        life: 3000,
      });
      return;
    }
    confirmDialog({
      message: "Do you want to publish this quiz? Please ensure all questions are correctly mapped.",
      header: "Confirmation",
      icon: "pi pi-info-circle",
      accept: async () => {
        try {
          await publishQuiz(rowData.id);
          const updatedData = selectedQuiz.map((item) =>
            item.id === rowData.id ? { ...item, is_published: true } : item
          );
          setSelectedQuiz(updatedData);
          toast.current.show({
            severity: "success",
            summary: "Published",
            detail: "Quiz has been published successfully.",
            life: 3000,
          });
        } catch (error) {
          console.error("Error publishing quiz:", error);
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "Failed to publish quiz.",
            life: 3000,
          });
        }
      },
    });
  };

  const handleQuestionMap = (quiz) => {
    setSelectedQuiz(quiz);
    setShowPublishDialog(true);
    setIsQuestionMapped(false);
  };
  const handleClosePublishDialog = () => {
    setShowPublishDialog(false);
    setShowViewModal(false);
    setSelectedQuiz([]);
    setViewMappedQuiz([]);
  };
  const handleUpdateQuizClick = () => {
    if (selectedQuiz.length === 1) {
      const quizData = selectedQuiz[0];
      navigate("/quizzes?tab=edit", {
        state: {
          mode: "update",
          quiz: quizData,
        },
      });
      setShowAddQuizModal(true);
    }
  };

  const fetchQuizzes = async (page,pageSize) => {
    try {
     const result = await getQuizFromServer(page, pageSize);
     const sorted = result.data.sort((a, b) => a.title.localeCompare(b.title));
      setDataitem(sorted);
      setPage(result.page);
      setPageSize(result.pageSize);
      setTotalCount(result.total);
    } catch (error) {
      setDataitem([]);
      setTotalCount(0)
      console.error("Error fetching quizzes:", error);
    }
  };
  useEffect(() => {
    fetchQuizzes(page,pageSize);
  }, [page,pageSize]);
  const handleModalClose = () => {
    setShowAddQuizModal(false);
    fetchQuizzes(page,pageSize);
  };
  const handleTablePageChange = (newPage, newPageSize) => {
    setPage(newPage);
    setPageSize(newPageSize);
  };
  const [filters, setFilters] = useState({});
  const onFilter = (e, field) => {
    const value = e.target.value;
    setFilters({ ...filters, [field]: value });
  };
  const filteredData = dataitem.filter((item) => {
    return Object.keys(filters).every((key) =>
      item[key]?.toString().toLowerCase().includes(filters[key]?.toLowerCase())
    );
  });
  const searchTemplate = (field) => (
    <InputText
      value={filters[field] || ""}
      onChange={(e) => onFilter(e, field)}
      placeholder={`Search ${field}`}
      className="p-column-filter"
    />
  );

  const navigate = useNavigate();
  const getBorderClassName = () => {
    return "border-second";
  };
  const renderTooltipComponent = (rowData) => (
    <>
      {" "}
      {rowData.validStatus !== "Valid" && rowData.remarks ? (
        <>
          <Tooltip
            target={`#tooltip_${rowData.id}`}
            mouseTrack
            mouseTrackLeft={2}
            mouseTrackTop={2}
          >
            <div
              style={{
                maxWidth: "281px",
                backgroundColor: "#fff",
                padding: "5px",
                color: "black",
              }}
            >
              <p
                style={{
                  color: "#E03581",
                  margin: 0,
                  fontWeight: "700",
                }}
              >
                {rowData.remarks}
              </p>
            </div>
          </Tooltip>
          <span id={`tooltip_${rowData.id}`} data-testid="Exclamation">
            <img
              id={`tooltip_${rowData.id}`}
              src={Excalmation}
              alt="Exclamation"
            />
          </span>
        </>
      ) : null}{" "}
    </>
  );
  const handleDeleteQuiz = async () => {
    if (selectedQuiz.length === 0) {
      toast.current.show({
        severity: "warn",
        summary: "Warning",
        detail: "Please select at least one Quiz to delete.",
        life: 3000,
      });
      return;
    }
    confirmDialog({
      message: `Are you sure you want to delete the selected Quiz`,
      header: "Confirmation",
      icon: "pi pi-info-circle",
      accept: async () => {
        let successCount = 0;
        let failedCount = 0;

        for (const quiz of selectedQuiz) {
          try {
            await deleteQuiz(quiz.id);
            successCount++;
          } catch (error) {
            console.error("Error deleting quiz:", error.message);
            toast.current.show({
              severity: "warn",
              summary: "Warning",
              detail: error.message || "Failed to delete quiz.",
              life: 5000,
            });
            failedCount++;
          }
        }
        if (successCount > 0) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: `Quiz deleted successfully.`,
            life: 3000,
          });
        }
        setSelectedQuiz([]);
        fetchQuizzes();
      },
    });
  };

  return (
    <>
      <Toast ref={toast} />
      <div className="masterScreen">
                <div className="grid flex justify-content-end mb-4" style={{ marginLeft: '51.5rem'}}>
          <div className="md:col-6 col-div"></div>
          <div className="sm:col-12 md:col-6 button_section">
                        <div className="flex justify-content-end align-items-center mt-4 mb-2 gap-18 w-full">
              <div className="flex justify-content-end align-items-center mb-2 gap-2 w-full">
                <Button
                  className="master-updateBtn"
                  label="Update"
                  severity="info"
                  icon={<img src={updateIconImg} alt="Update icon" />}
                  outlined
                  disabled={selectedQuiz.length !== 1}
                  tooltip="Update Quiz"
                  tooltipOptions={{ position: "bottom", event: "both" }}
                  onClick={handleUpdateQuizClick}
                />
                <Button
                  className="master-deleteBtn"
                  label="Delete"
                  severity="danger"
                  icon={<img src={deleteIconImg} alt="Delete icon" />}
                  outlined
                  disabled={selectedQuiz.length === 0}
                  onClick={handleDeleteQuiz}
                />
                <Button
                  className="addBtn"
                  label="Add New Quiz"
                  icon={<img src={addIcon} alt="Add icon" />}
                  disabled={selectedQuiz.length > 0}
                  tooltip="Add New Quiz"
                  tooltipOptions={{ position: "bottom", event: "both" }}
                  onClick={() => {
                    navigate("/quizzes?tab=add");
                    handleAddQuizClick();
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <DataTable
          lazy
          className="table-viewport custom-tooltip"
          resizableColumns
          value={filteredData}
          size="small"
          dataKey="id"
          emptyMessage="No data found."
          filterDisplay="row"
          scrollable
          scrollHeight="510px"
          paginator
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
           rows={pageSize}
          first={(page - 1) * pageSize}
          rowsPerPageOptions={[5, 10, 20, 50]} 
          onPage={(e) => {
            const newPage = Math.floor(e.first / e.rows) + 1;
            const newPageSize = e.rows;
            handleTablePageChange(newPage, newPageSize);
          }}
          totalRecords={totalCount}
          selection={selectedQuiz}
          onSelectionChange={(e) => setSelectedQuiz(e.value)}
        >
          <Column
            selectionMode="multiple"
            header="Select"
            frozen
            alignFrozen="left"
          />
          <Column
            frozen={true}
            alignFrozen="left"
            body={(rowData) => renderTooltipComponent(rowData)}
          />
          <Column
            frozen={true}
            alignFrozen="left"
            field="QuizTranslations.title"
            header=" Quiz Title"
            filter
            showFilterMenu={false}
            filterPlaceholder="Search"
            filterElement={() => searchTemplate("title")}
            style={{ cursor: "pointer" }}
          />
          <Column
            frozen={true}
            headerStyle={{
              borderRight: "3px solid #d9d9d9",
              position: "sticky",
            }}
            bodyStyle={{
              borderRight: "3px solid #d9d9d9",
              position: "sticky",
            }}
            alignFrozen="left"
            className={getBorderClassName()}
          />
          <Column
            frozen={true}
            alignFrozen="left"
            field="quiz_type"
            header="Quiz Type"
            filter
            showFilterMenu={false}
            filterPlaceholder="Search"
            filterElement={() => searchTemplate("quiz_type")}
            style={{ cursor: "pointer" }}
          />
          <Column
            frozen={true}
            alignFrozen="left"
            field="roles"
            header="Roles"
            filter
            showFilterMenu={false}
            filterPlaceholder="Search"
            filterElement={() => searchTemplate("roles")}
            body={(rowData) => rowData.roles?.join(", ") || "-"}
            style={{ cursor: "pointer" }}
          />
          <Column
            field="published_date"
            header="Scheduled Publish Date"
            body={(rowData) => {
              const date = rowData.published_date;
              return date ? new Date(date).toISOString().split("T")[0] : "-";
            }}
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          />
          <Column
            frozen={true}
            alignFrozen="left"
            field="start_date"
            header="Start Date"
            body={(rowData) =>
              new Date(rowData.start_date).toISOString().split("T")[0]
            }
            style={{ cursor: "pointer" }}
          />
          <Column
            frozen={true}
            alignFrozen="left"
            field="end_date"
            header="End Date"
             body={(rowData) => {
              const date = rowData.published_date;
              return date ? new Date(date).toISOString().split("T")[0] : "-";
            }}
            style={{ cursor: "pointer" }}
          />
          <Column
            header="Map Questions"
            body={(rowData) => (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <i
                  className="pi pi-link"
                  style={{
                    cursor: "pointer",
                    fontSize: "1.2rem",
                    color: "blue",
                  }}
                  onClick={() => handleQuestionMap(rowData)}
                  title="Map Questions"
                />
              </div>
            )}
          />
          <Column
            field="is_published"
            header="Publish Quiz"
            body={(rowData) => (
              <div className="custom-small-toggle">
              <InputSwitch
                checked={rowData.is_published}
                onChange={() => handlePublishToggle(rowData)}
              />
              </div>
            )}
          />
          <Column
            header="View Mapped"
            body={(rowData) => (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <i
                  className="pi pi-eye"
                  style={{
                    cursor: "pointer",
                    fontSize: "1.2rem",
                    color: "#1d2965",
                  }}
                  onClick={() => handleViewMappedQuestions(rowData)}
                  title="View Mapped Questions"
                />
              </div>
            )}
          />
        </DataTable>
        <p className="text-sm">{totalCount} Total record</p>
      </div>
      <DialogComponent
        visible={showAddQuizModal}
        onHide={handleModalClose}
        header={
          <ModalHeader onClose={handleModalClose} backText="Back To Quiz" />
        }
        style={{
          width: "100vw",
          maxWidth: "1000px",
          height: "100vh",
        }}
      >
        <QuizForm onClose={handleModalClose} />
      </DialogComponent>
      <DialogComponent
        visible={showPublishDialog}
        onHide={handleClosePublishDialog}
        header={
          <ModalHeader
            onClose={handleClosePublishDialog}
            backText="Back To Quiz"
          />
        }
        style={{
          width: "80vw",
          maxWidth: "1500px",
          height: "auto",
        }}
      >
        <QuizeViewModal
          onClose={handleClosePublishDialog}
          selectedItem={selectedQuiz[0]}
          isQuestionMapped={isQuestionMapped}
        />
      </DialogComponent>
      <DialogComponent
        visible={showViewModal}
        onHide={handleClosePublishDialog}
        header={
          <ModalHeader
            onClose={handleClosePublishDialog}
            backText="Back To Quiz"
          />
        }
        style={{
          width: "80vw",
          maxWidth: "1500px",
          height: "auto",
        }}
      >
        <QuizeViewModal
          onClose={handleClosePublishDialog}
          selectedItem={viewMappedQuiz}
          isQuestionMapped={isQuestionMapped}
        />
      </DialogComponent>
      <ConfirmDialog />
    </>
  );
}

export default QuizzesView;